import React from "react";
import mtzApis from "../../../../services";
import CategorySelect from "../CategorySelect";
const { companyService } = mtzApis;

export default function CompanyCategorySelect({ onChange, categoryIds, title, subtitle }) {
  React.useEffect(() => {
    (async () => {

    })();
  }, []);
  return (
    <CategorySelect
      title={title}
      subtitle={subtitle}
      categoryIds={categoryIds}
      onChange={onChange}
      categoryResourceLimit={5}
    />
  );
}
